<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_12"></a><img alt="Image" src="images/f0012-01.jpg"/></p>
<h2 class="h2a"><a id="page_13"></a><a id="part1"></a>PART 1<br/>Outfitting the <strong>Jeweler’s Studio</strong></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00g_part1.vue?3a6f527e